export function noticeError(
  error: string | Error,
  data?: Record<string, string | number> | undefined,
) {
  if (!data) {
    window?.NREUM?.noticeError(error);
  } else {
    window?.NREUM?.noticeError(error, data);
  }
}

export function setApplicationVersion(version: string) {
  window?.NREUM?.setApplicationVersion(version);
}
